import { User } from "@fairfleet/geotab";
import { useCallback, useMemo } from "react";
import { useUsersByUserIds } from "@/hooks/users/useUsersByUserIds";

export type DriverLabel = (driverId: string) => string;

function driverName(user: User): string {
  const full = [user.firstName, user.lastName].filter(Boolean).join(" ");
  return full || user.name || user.id;
}

/**
 * How a driver is named on the page: with `showsNames` the driver's name from Geotab, otherwise
 * (the customs auditor) only the Geotab user id. Names are loaded only when they are shown.
 */
export function useDriverLabels(driverIds: string[], showsNames: boolean) {
  const ids = useMemo(() => [...new Set(driverIds)].sort(), [driverIds]);
  const { data: users } = useUsersByUserIds(showsNames ? ids : undefined);

  const names = useMemo(() => {
    const map = new Map<string, string>();
    for (const user of users ?? []) if (user.id) map.set(user.id, driverName(user));
    return map;
  }, [users]);

  const driverLabel = useCallback<DriverLabel>(id => names.get(id) ?? id, [names]);
  return { driverLabel };
}
